import { GradientHeader } from "@/components/block/GradientHeader";
import HtmlDiff from 'htmldiff-js';
import { getDrupalPageFromPath } from "@/lib/drupal/drupal.server";
import { DrupalNode, DrupalNodeExternalResource } from "@/types";
import { AcquiaStatus } from "@/components/app/status/AcquiaStatus";
import { Suspense } from "react";
import { LoadExternalResource } from "@/lib/drupal/external-resource";

export default async function Header({ params }: {
  params: {
    slug: string[]
  }
}) {
  const path = params.slug.join('/')
  try {
    const {resource, revision} = await getDrupalPageFromPath<DrupalNode>(`/${path}`)
  
    if (resource === null) {
      return;
    }
  
    const showDiff = false
  
    const titleContent = await getTitle(resource, revision ?? undefined, showDiff, path)
    const node = revision ?? resource;
    const last_updated = new Date(node.changed);
    const product = node.field_product ?? node.field_products[0];
  
    return (
        <>
        <GradientHeader 
          title={titleContent} 
          eyebrow={product?.name} 
          productLogo={product?.field_product_logo ?? 'cloud_platform'} 
          isAddOn={product.parent[0].id != "virtual"}>
        <p className="text-xs italic text-gray-600 hidden print:block">{ last_updated.toDateString() } { last_updated.toTimeString() }</p>
        {node.type == 'node--external_resource' && <Suspense>
          <ExternalResourceHeaderChildren node={node} path={path} />
        </Suspense>}
        </GradientHeader>
        {['node--page', 'node--release'].includes(node.type) && <Suspense><AcquiaStatus product={product} /></Suspense>}
        </>
    )
  }
  catch (err) {
    console.error({err})
    return <></>
  }
}

const ExternalResourceHeaderChildren = ({node, path}: {node: DrupalNodeExternalResource, path: string}) => {
  const externalResource = LoadExternalResource(node);
  return externalResource.getHeaderChildren(path);
}

export const getTitle = async (resource: DrupalNode, revision?: DrupalNode, showDiff: boolean = false, path: string = '') => {
  if (resource.type == 'node--external_resource') {
    const externalResource = LoadExternalResource(resource);
    return await externalResource.getPageTitle(path);
  }
  const titleContent: string = (revision && showDiff) ? HtmlDiff.execute(resource.title, revision.title) : revision?.title ?? resource.title;
  // if (resource.type == 'node--release') {
  //   return `Release notes - ${titleContent}`
  // }
  return titleContent
}